// extracted by mini-css-extract-plugin
export var orderSummary = "_t1-0";
export var showMoreLessButton = "_t1-1";